import { Vue } from 'vue-property-decorator';
import { numberFormat, numberFormatWithTextSuffix } from '@/helpers/number-format';
import moment from 'moment';
import { isEmptyValue } from '@/utils/utils';

Vue.filter('avatarText', (value: any) => {
    let avatar = '';
    (value.split(' ')).map((words: any) => {
        avatar += words.toString().charAt(0).toUpperCase();
    });
    return avatar.substr(0, 3);
});

Vue.filter('contentFormator',  (value: any, text: string) => {
    const arrayString = value.split('_') || '';
    const removeString = arrayString.filter((item: string) => item !== text);
    return  removeString.join(' ');
});

Vue.filter('formatNumber', (value: number) => {
    return value ? numberFormat(value) : 0;
});

Vue.filter('percentage', (value: number, total: number) => {
    return Math.round(value * 100 / total);
});

Vue.filter('numtostring', (value: number) => {
    return value ? numberFormatWithTextSuffix(value) : 0;
});

Vue.filter('date', (value: number) => {
    const newDate = new Date(value);
    return moment(newDate).format('MM-DD-YYYY');
});

Vue.filter('dateTime', (value: number) => {
    const newDate = new Date(value);
    return moment(newDate).format('MM-DD-YYYY, h:mm a');
});

Vue.filter('dateCustom', (value: number , format: string) => {
    const newDate = new Date(value);
    return moment(newDate).format(format);
});

Vue.filter('getKey', (object: any) => {
    const key = Object.keys(object);
    return key[0];
});

Vue.filter('mask', (value: any) => {
    if (value) {
        const emailSplit = value.split('@');
        const name = emailSplit[0] ? emailSplit[0] : '';
        const totalLength = name.length;
        const viewFields = name.substr(0, 2);
        const maskedLetter = new Array(totalLength - 2).fill('*').join('');
        return viewFields + maskedLetter + '@' + emailSplit[1];
    }
    return 'NA';
});


Vue.filter('volumeConverter', (value: any) => {
    if (value) {
        const convertMB = value / 1024;
        if (convertMB > 1) {
            const convertGB = convertMB / 1024;
            if (convertGB > 1) {
                return convertGB.toFixed(1) + ' GB';
            }
            return convertMB.toFixed(1) + ' MB';
        }
        return value + ' KB';
    }
    return `0 KB`;
});

Vue.filter('stripHtml', (html: any) => {
    if (!isEmptyValue(html)) {
        const tmp = document.createElement('DIV');
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || '';
    }
});

